import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Loader from '../../components/elements/Loader';
import TableComponent from '../../components/elements/TableComponent';
import useDebounce from '../../hooks/useDebounce';
import SearchBar from '../elements/SearchBar';
import { fetchErrorLogs } from '../../modules/admin';
import { logsFields } from '../project-dashboard/test-case/testCaseTableHead';
import { Refresh } from '@mui/icons-material';

const LogsTable = () => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [order, setOrder] = useState('desc');
  const [totalCount, setTotalCount] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const perPage = 10;
  const debouncedSearchQuery = useDebounce(searchValue, 500);

  const fetchData = async (pageNumber) => {
    try {
      setLoading(true);
      const pageToFetch = pageNumber !== undefined ? pageNumber : page;
      const data = await fetchErrorLogs(
        pageToFetch,
        perPage,
        debouncedSearchQuery
      );

      setItems(data?.logs || []);
      setTotalCount(data?.total || 0);
      setError(null);
    } catch (error) {
      console.error('Fetch Logs Error:', error);
      setError(
        error.message || 'An unexpected error occurred while fetching logs'
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (page === 1) {
      fetchData(1);
    } else {
      setPage(1);
    }
  }, [debouncedSearchQuery]);
  
  useEffect(() => {
    fetchData(page);
  }, [page]);

  return (
    <>
      <Row>
        <Col>
          <Typography variant="h4" className="mb-3">
            Logs
          </Typography>
        </Col>
      </Row>
      <Stack
        className="mb-3"
        direction="horizontal"
        gap={2}
        justifyContent={'space-between'}>
        <div style={{ width: '500px' }}>
          <SearchBar
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            clearSearch={() => setSearchValue('')}
            placeholder="Search email, body, URL, or status..."
          />
        </div>

        <Button
          variant="outlined"
          color="secondary"
          disableRipple
          onClick={() => fetchData(page)}
          title="Click to refresh logs">
          {loading ? (
            <CircularProgress size={18} color="inherit" />
          ) : (
            <Refresh size={'18px'} />
          )}
        </Button>
      </Stack>

      <Row>
        <Col>
          {loading ? (
            <Loader />
          ) : error ? (
            <div className="alert alert-danger">{error}</div>
          ) : (
            <TableComponent
              data={items}
              headerTabs={logsFields}
              page={page}
              handlePageChange={setPage}
              perPage={perPage}
              order={order}
              setOrder={setOrder}
              defaultSort="createdAt"
              isLoading={loading}
              striped
              totalCount={totalCount}
              showPages
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default LogsTable;
